t = require('views/internal/teacup-with-helpers')('popover_helper_new_board_add_org')

module.exports = ->
  t.p ->
    t.format 'an-organization-is-a-collection-of-members-and-boards-they-make-sharing-and-working-within-a-group-even-easier'

  t.a '.button.js-create-org', { href: '#' }, ->
    t.format 'create-an-organization'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_helper_new_board_add_org.coffee